<template>
  <div class="m-common__review__images large">
    <ul class="photoswipeGroup" v-if="images.length">
      <li class="photoswipeImages" v-for="(image, index) in images" :key="skuCode + String(index)" v-if="index < maxImageSize">
        <span :data-src="image.path" data-size=""><img :src="image.path" alt=""></span>
      </li>
    </ul>
  </div>
</template>

<script>
import urls from '@/mixins/urls'
export default {
  name: 'BaseReviewImageThumbsForWidget',
  mixins: [ urls ],
  props: {
    skuCode: {
      type: String,
      required: true
    },
    images: {
      type: Array,
      default: {}
    },
    maxImageSize: {
      type: Number,
      default: 12
    }
  },
  computed: {
    reviewImageUrl () {
      return this.getReviewImageUrl(this.skuCode)
    }
  },
  mounted () {
    this.initializePhotoSwipe()
  },
  methods: {
    initializePhotoSwipe () {
      if (window.$) {
        const $ = window.$
        const vm = this
        $(window).on('resize.' + this.reviewId, function () {
          $('.photoswipeImages [data-src]', vm.$el).each(function () {
            const $src = $(this)
            $src.height($src.width())
          })
        })
        const $srcs = $('.photoswipeImages [data-src]', vm.$el)
        let count = $srcs.length
        $srcs.find('img').off('load.hoge').on('load.hoge', function () {
          const $img = $(this)
          const $src = $img.parent('[data-src]')
          $src.height($src.width())
          const w = this.naturalWidth
          const h = this.naturalHeight
          if (w > h) {
            $img.addClass('fit-height')
          } else if (w < h) {
            $img.addClass('fit-width')
          }
          if (--count === 0) {
            $('.pswp').remove()
            window.initPhotoSwipeFromDOM('.photoswipeGroup', '.photoswipeImages')
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BaseReviewImageThumbsForWidget.vue